<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 step">
        <div v-if="showErrors">
          <div class="text-danger border border-danger m-4">
            {{ showErrors }}
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="this.$root.serviceSetting.enable_membership.value === '1' && this.$root.$route.query.dev !== 'tab' && !this.$root.$store.state.loadedMembership && !this.$root.$store.state.isCRMMember">
      <div class="col text-right">
        <button class="btn btn-primary" data-testid="step2_repeater_load" @click="showMemberModal">{{ $t('レンタル会員情報を読み込む') }}</button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col text-left">
        <div class="form-group" v-if="this.$store.state.isCRMMember">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('会員番号') }} *</div>
          {{ this.$root.$store.state.crm_id }}
        </div>
        <div class="form-group">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('携帯電話番号') }} *</div>
          <input type="number" class="form-control" data-testid="step2_tel" :value="this.$root.$store.state.tel" @input="updateTel"
                 autocomplete="tel"
                 @focus="show" data-layout="phone" :readonly="this.$root.$route.query.dev == 'tab2' || this.$store.state.locked.tel">
          <div v-for="(e, index) in showInputError('tel')" :key="'error-tel-' + index" class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group mt-4" v-if="this.$root.$route.query.dev !== 'tab'">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('message.email') }} *</div>
          <input type="email" class="form-control" data-testid="step2_email" :value="this.$root.$store.state.email" @input="updateEmail"
                 autocomplete="email"
                 @focus="show" data-layout="email" :readonly="this.$root.$route.query.dev == 'tab2' || this.$store.state.locked.email">
          <div v-for="(e, index) in showInputError('email')" :key="'error-email-' + index"
               class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group mt-4" v-if="this.$root.$route.query.dev !== 'tab' && !this.$root.$store.state.isCRMMember">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('message.email_retype') }}</div>
          <input type="email" class="form-control" data-testid="step2_email_retype" :value="this.$root.$store.state.email_retype"
                 autocomplete="email"
                 @input="updateEmailRetype" @focus="show" data-layout="email"
                 :readonly="this.$root.$route.query.dev == 'tab2' || this.$store.state.locked.email">
          <div v-for="(e, index) in showInputError('email_retype')" :key="'error-email_retype-' + index"
               class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group mt-4" v-if="this.$root.$route.query.dev !== 'tab' && this.$root.serviceSetting.enable_country.value === 'true'">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('居住国') }}</div>
          <div class="example" :data-selectedcountry="this.$root.$store.state.country"
               id="country"
               data-showspecial="false"
               data-showflags="true"
               data-i18nall="All selected"
               data-i18nnofilter="No selection"
               data-i18nfilter="Filter"
               data-onchangecallback="onChangeCallback">
          </div>
          <input type="hidden" id="country-value" :value="this.$root.$store.state.country">
          <div v-for="(e, index) in showInputError('country')" :key="'error-country-' + index"
               class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group mt-4" id="address1" v-if="this.$root.$route.query.dev !== 'tab' && this.$root.serviceSetting.enable_pref.value === 'true'">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('居住エリア') }}</div>
          <select @change="updateArea" class="form-control">
            <option v-for="(k, index) in prefs" :key="index" :value="k.kanji" :selected="$root.$store.state.address1 === k.kanji">{{k.kanji}}</option>
          </select>
          <div v-for="(e, index) in showInputError('address1')" :key="'error-area-' + index"
               class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group" v-if="this.$root.serviceSetting.enable_address.value === 'true'">
          <div class="form-control-static"><i class="fas fa-user"></i> {{ $t('message.zip') }}</div>
          <input type="text" class="form-control" :value="this.$root.$store.state.zip" @input="updateZip"
                 @focus="show" data-layout="zip">
          <div v-for="(e, index) in showInputError('zip')" :key="'error-zip-' + index" class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group" v-if="this.$root.serviceSetting.enable_address.value === 'true'">
          <div class="form-control-static"><i class="fas fa-user"></i> {{ $t('message.address') }} *</div>
          <input type="text" class="form-control" :value="this.$root.$store.state.address2"
                 @input="updateAddress" data-layout="normal">
          <div v-for="(e, index) in showInputError('address')" :key="'error-address-' + index"
               class="text-danger">
            {{ $t(e.message) }}
          </div>
        </div>
        <div class="form-group mt-4">
          <div class="form-control-static design1"><i class="fas fa-user"></i> {{ $t('message.idcard') }} *</div>
          <div class="btn-group-m1 form-box">
            <button
                v-for="(v, i) in this.$root.$store.state.selectOptions.IDC"
                :key="i"
                :class="{btn: true, 'btn-light': $root.$store.state.idcard != v.value, 'btn-info': $root.$store.state.idcard == v.value}"
                data-testid="step2_idcard"
                @click="updateIdCard"
                :value="v.value"
            >
              {{ $t(v.name) }}
            </button>
          </div>
        </div>
        <div class="form-group mt-4" style="display: none">
          <div class="form-check form-check-inline">
            <input type="checkbox" id="privacy" class="form-check-input" data-testid="step2_privacy_check"
                   :checked="this.$root.$store.state.privacy == 1" :value="1" @click="updatePrivacy">
            <label class="form-check-label" for="privacy">
              {{ $t('個人情報の取り扱いに同意する。') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button @click="toNextStep()" data-testid="nav_next" class="btn btn-primary btn-lg btn-h-6 design4 Rental_cv2 btn-3d btn-sm-100">
          {{ $t('message.goToCart') }} <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
    <vue-touch-keyboard id="keyboard" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input"
                        :next="next" style="width: 95vw"></vue-touch-keyboard>

    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" id="membershipModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('レンタル会員情報の読み込み') }}
          </div>
          <div class="modal-body">
            <div class="row" v-if="loadCompleted === true">
              <div class="col text-left">
                {{ $t('会員情報を読み込みました。') }}
              </div>
              <!--
              <div class="col-12">
                <template v-if="memberData.members">
                  <div v-for="(member, index) in memberData.members" :key="index">
                    <input type="checkbox">
                    {{member.last_name}} {{member.first_name}}
                  </div>
                </template>
              </div>
              -->
            </div>
            <div class="row" v-else>
              <div class="col">
                <div class="form-group">
                  <div class="form-control-static text-left">
                    {{ $t('メールアドレス') }}
                  </div>
                  <input type="email" class="form-control" v-model="membership_email">
                </div>
                <div class="form-group">
                  <div class="form-control-static text-left">
                    {{ $t('パスワード') }}
                  </div>
                  <input type="password" class="form-control" v-model="membership_password">
                </div>
                <div class="text-danger" v-if="auth_errors">
                  <ul>
                    <li v-for="(err, index) in auth_errors" :key="index">
                      <span>{{ err }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-if="loadCompleted === false"  class="btn btn-success" @click="loadMembership">{{ $t('読み込む') }}</button>
            <button v-if="loadCompleted === false"  class="btn btn-default" data-dismiss="modal">{{ $t('キャンセル') }}</button>
            <button v-if="loadCompleted === true" class="btn btn-success" data-dismiss="modal">{{ $t('閉じる') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import Underscore from 'vue-underscore'
import axios from 'axios'

Vue.use(VueTouchKeyboard)
Vue.use(style)
Vue.use(Underscore)

export default {
  name: 'UserDetail',
  computed: {
    showErrors () {
      if (this.errors.length > 0) {
        console.log('errors', this.errors)
        return this.$t('入力内容を確認してください')
      }
      return null
    }
  },
  components: {
    'vue-touch-keyboard': VueTouchKeyboard.component
  },
  data () {
    return {
      errors: {},
      visible: false,
      input: null,
      layout: 'normal',
      auth_errors: [],
      membership_email: '',
      membership_password: '',
      options: {
        useKbEvents: false,
        preventClickEvent: false
      },
      loadCompleted: false,
      memberData: {},
      prefs: [
        {
          'kanji': '北海道',
          'yomi': 'ほっかいどう',
          'roma': 'hokkaido'
        },
        {
          'kanji': '青森県',
          'yomi': 'あおもり',
          'roma': 'aomori'
        },
        {
          'kanji': '岩手県',
          'yomi': 'いわて',
          'roma': 'iwate'
        },
        {
          'kanji': '宮城県',
          'yomi': 'みやぎ',
          'roma': 'miyagi'
        },
        {
          'kanji': '秋田県',
          'yomi': 'あきた',
          'roma': 'akita'
        },
        {
          'kanji': '山形県',
          'yomi': 'やまがた',
          'roma': 'yamagata'
        },
        {
          'kanji': '福島県',
          'yomi': 'ふくしま',
          'roma': 'fukushima'
        },
        {
          'kanji': '茨城県',
          'yomi': 'いばらき',
          'roma': 'ibaraki'
        },
        {
          'kanji': '栃木県',
          'yomi': 'とちぎ',
          'roma': 'tochigi'
        },
        {
          'kanji': '群馬県',
          'yomi': 'ぐんま',
          'roma': 'gunma'
        },
        {
          'kanji': '埼玉県',
          'yomi': 'さいたま',
          'roma': 'saitama'
        },
        {
          'kanji': '千葉県',
          'yomi': 'ちば',
          'roma': 'chiba'
        },
        {
          'kanji': '東京都',
          'yomi': 'とうきょう',
          'roma': 'tokyo'
        },
        {
          'kanji': '神奈川県',
          'yomi': 'かながわ',
          'roma': 'kanagawa'
        },
        {
          'kanji': '新潟県',
          'yomi': 'にいがた',
          'roma': 'niigata'
        },
        {
          'kanji': '富山県',
          'yomi': 'とやま',
          'roma': 'toyama'
        },
        {
          'kanji': '石川県',
          'yomi': 'いしかわ',
          'roma': 'ishikawa'
        },
        {
          'kanji': '福井県',
          'yomi': 'ふくい',
          'roma': 'fukui'
        },
        {
          'kanji': '山梨県',
          'yomi': 'やまなし',
          'roma': 'yamanashi'
        },
        {
          'kanji': '長野県',
          'yomi': 'ながの',
          'roma': 'nagano'
        },
        {
          'kanji': '岐阜県',
          'yomi': 'ぎふ',
          'roma': 'gifu'
        },
        {
          'kanji': '静岡県',
          'yomi': 'しずおか',
          'roma': 'shizuoka'
        },
        {
          'kanji': '愛知県',
          'yomi': 'あいち',
          'roma': 'aichi'
        },
        {
          'kanji': '三重県',
          'yomi': 'みえ',
          'roma': 'mie'
        },
        {
          'kanji': '滋賀県',
          'yomi': 'しが',
          'roma': 'shiga'
        },
        {
          'kanji': '京都府',
          'yomi': 'きょうと',
          'roma': 'kyoto'
        },
        {
          'kanji': '大阪府',
          'yomi': 'おおさか',
          'roma': 'osaka'
        },
        {
          'kanji': '兵庫県',
          'yomi': 'ひょうご',
          'roma': 'hyogo'
        },
        {
          'kanji': '奈良県',
          'yomi': 'なら',
          'roma': 'nara'
        },
        {
          'kanji': '和歌山県',
          'yomi': 'わかやま',
          'roma': 'wakayama'
        },
        {
          'kanji': '鳥取県',
          'yomi': 'とっとり',
          'roma': 'tottori'
        },
        {
          'kanji': '島根県',
          'yomi': 'しまね',
          'roma': 'shimane'
        },
        {
          'kanji': '岡山県',
          'yomi': 'おかやま',
          'roma': 'okayama'
        },
        {
          'kanji': '広島県',
          'yomi': 'ひろしま',
          'roma': 'hiroshima'
        },
        {
          'kanji': '山口県',
          'yomi': 'やまぐち',
          'roma': 'yamaguchi'
        },
        {
          'kanji': '徳島県',
          'yomi': 'とくしま',
          'roma': 'tokushima'
        },
        {
          'kanji': '香川県',
          'yomi': 'かがわ',
          'roma': 'kagawa'
        },
        {
          'kanji': '愛媛県',
          'yomi': 'えひめ',
          'roma': 'ehime'
        },
        {
          'kanji': '高知県',
          'yomi': 'こうち',
          'roma': 'kochi'
        },
        {
          'kanji': '福岡県',
          'yomi': 'ふくおか',
          'roma': 'fukuoka'
        },
        {
          'kanji': '佐賀県',
          'yomi': 'さが',
          'roma': 'saga'
        },
        {
          'kanji': '長崎県',
          'yomi': 'ながさき',
          'roma': 'nagasaki'
        },
        {
          'kanji': '熊本県',
          'yomi': 'くまもと',
          'roma': 'kumamoto'
        },
        {
          'kanji': '大分県',
          'yomi': 'おおいた',
          'roma': 'oita'
        },
        {
          'kanji': '宮崎県',
          'yomi': 'みやざき',
          'roma': 'miyazaki'
        },
        {
          'kanji': '鹿児島県',
          'yomi': 'かごしま',
          'roma': 'kagoshima'
        },
        {
          'kanji': '沖縄県',
          'yomi': 'おきなわ',
          'roma': 'okinawa'
        }
      ]
    }
  },
  mounted () {
    window.sendGtag({
      'page_path': '/reserve-app/step2'
    })
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.getCodes()
    if (this.$root.$store.state.lang) {
      this.$root.$i18n.locale = this.$root.$store.state.lang
    }
    if (this.$root.$route.query.email) {
      this.$root.$store.commit('update', { field: 'email', value: this.$root.$route.query.email })
      this.$root.$store.commit('update', { field: 'email_retype', value: this.$root.$route.query.email })
    }
    console.log('enable_pref', this.$root.serviceSetting.enable_pref.value, !this.$root.$store.state.address1)
    this.setDefaultArea()
    window.onChangeCallback = (crt) => {
      window.jQuery('#country-value').val(crt)
      this.$root.$store.commit('update', { field: 'country', value: crt })
      // 日本に戻したときは居住エリアが空になっているので既定値を入れ直す #190
      this.setDefaultArea()
      window.address1Control()
    }
    new window.NiceCountryInput(window.jQuery('#country')).init()
    // 居住エリアの表示/非表示を現在の居住国に合わせる #190
    // address1Control() は初回ロードと居住国の変更時にしか呼ばれないため、
    // 3画面目から戻ったときに居住国が海外でも居住エリアが表示されたままだった
    window.address1Control()
    this.getOptionValue()
    // テスト用
    // window.jQuery('.modal-backdrop').hide()
    // window.jQuery('#membershipModal').modal('show')
  },
  methods: {
    getCodes () {
      this.$emit('get-codes')
    },
    showMemberModal () {
      this.loadCompleted = false
      window.jQuery('#membershipModal').modal('show')
    },
    returnStep1 (e) {
      if (confirm(this.$root.$t('入力した内容を全て破棄して、申込のトップ画面に戻ります。'))) {
        let resetUrl = '/reserve-app/?ui=' + this.$root.$store.state.userId + '&'
        if (this.$root.$route.query.email !== undefined) {
          resetUrl += '&email=' + this.$root.$route.query.email
        }
        if (this.$root.$route.query.dev !== undefined) {
          resetUrl += '&dev=' + this.$root.$route.query.dev
        }
        if (this.$root.$route.query.type !== undefined) {
          resetUrl += '&type=' + this.$root.$route.query.type
        }
        if (this.$root.$route.query.int !== undefined) {
          resetUrl += '&int=' + this.$root.$route.query.int
        }

        window.sessionStorage.clear()
        console.log('resetUrl', resetUrl)
        window.location.href = resetUrl
        // this.$root.$store.commit('initState')
        // this.$root.$store.commit('update', { field: 'step', value: 1 })
      }
    },
    toNextStep (e) {
      if (this.checkForm()) {
        console.log('isCRMMember', this.$root.$store.state.isCRMMember)
        if (this.$root.$store.state.isCRMMember) {
          this.loadPreviousCRMReserve()
        }
        if (window.jQuery('#country-value').val() !== 'JP') {
          this.$root.$store.commit('update', { field: 'address1', value: '' })
        }
        this.$root.$store.commit('update', { field: 'country', value: window.jQuery('#country-value').val() })
        this.$root.$store.commit('update', { field: 'step', value: 3 })
      }
    },
    showInputError (field) {
      let res = this.$_.where(this.errors, { field: field })
      if (res) {
        return res
      }
    },
    addError (field, message) {
      this.errors.push({
        field: field,
        message: message
      })
    },
    checkForm (e) {
      this.errors = []
      let v = this.$root.$store.state
      let required = [
        'tel', 'email', 'email_retype', 'reserve_term'
      ]
      if (this.$root.$route.query.dev === 'tab') {
        required = [
          'tel', 'reserve_term'
        ]
      }
      if (this.$root.$store.state.isCRMMember) {
        required = [
          'tel', 'reserve_term'
        ]
      }
      if (this.$root.$store.state.privacy === 1) {
        required.splice(0, 0, 'zip', 'address')
      }
      required.forEach((field, i) => {
        if (v[field] === '' || v[field] === null) {
          this.addError(field, 'message.errors.required')
        }
      })
      // tel
      if (v.tel !== '' && !v.tel.match(/^[0-9-]+$/)) {
        this.addError('tel', 'message.errors.tel.text_validation')
      }
      if (v.email !== '' && v.email.indexOf('@') <= 0) {
        this.addError('email', this.$root.$t('正しいメールアドレスの形式で入力してください'))
      }
      if (!this.$root.$store.state.isCRMMember && v.email !== '' && v.email !== v.email_retype) {
        this.addError('email_retype', 'message.errors.email_retype.not_match')
      }
      if (this.$root.serviceSetting.enable_address.value === 'true') {
        if (v.address2 === '') {
          this.addError('address2', 'message.errors.required')
        }
      }
      if (this.errors.length > 0) {
        return false
      }
      return true
    },
    updateArea (e) {
      this.$root.$store.commit('update', { field: 'address1', value: e.target.value })
    },
    // 居住エリアの既定値。居住国が日本のときだけ入れる #190
    // (海外を選んだ状態で3画面目から戻ると、toNextStep() でクリアされた居住エリアに
    //  「愛知県」が入り、居住国と矛盾した表示になっていた)
    setDefaultArea () {
      if (this.$root.serviceSetting.enable_pref.value !== 'true') {
        return
      }
      if (this.$root.$store.state.country !== 'JP') {
        return
      }
      if (!this.$root.$store.state.address1) {
        this.$root.$store.commit('update', { field: 'address1', value: '愛知県' })
      }
    },
    updateTel (e) {
      this.$root.$store.commit('update', { field: 'tel', value: e.target.value })
    },
    updateEmail (e) {
      this.$root.$store.commit('update', { field: 'email', value: e.target.value })
      this.membership_email = e.target.value
    },
    updateEmailRetype (e) {
      this.$root.$store.commit('update', { field: 'email_retype', value: e.target.value })
    },
    updateIdCard (e) {
      this.$root.$store.commit('update', { field: 'idcard', value: e.target.value })
    },
    updatePrivacy (e) {
      if (e.target.checked === true) {
        this.$root.$store.commit('update', { field: 'privacy', value: 1 })
      } else {
        this.$root.$store.commit('update', { field: 'privacy', value: 0 })
      }
    },
    updateZip (e) {
      this.$root.$store.commit('update', { field: 'zip', value: e.target.value })
    },
    updateAddress (e) {
      this.$root.$store.commit('update', { field: 'address2', value: e.target.value })
    },
    accept (text) {
      this.hide()
    },
    show (e) {
      if (this.$root.$route.query.dev !== 'tab2') {
        return true
      }
      let layout = e.target.dataset.layout
      e.target.readOnly = true
      this.input = e.target
      if (this.keyboardLayoutSet[layout]) {
        this.layout = this.keyboardLayoutSet[layout]
      }
      if (!this.visible) {
        this.visible = true
      }
    },
    hide () {
      this.visible = false
    },
    next () {
      let inputs = document.querySelectorAll('input')
      let found = false
      if (inputs) {
        [].forEach.call(inputs, (item, i) => {
          if (!found && item === this.input && i < inputs.length - 1) {
            found = true
            this.$nextTick(() => {
              inputs[i + 1].focus()
            })
          }
        })
        if (!found) {
          this.input.blur()
          this.hide()
        }
      }
    },
    getOptionValue () { // 必要？
      var date = this.$root.$store.state.rentalDate
      date = date.split('/').join('-')
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let int = this.$root.$route.query.int ? this.$root.$route.query.int : ''
      var url = this.$root.baseURL + 'getOptionName.json?ui=' + ui + '&datetime_base=' + date + '&int=' + int
      axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        let obj = response.data.result
        let options = {}
        Object.keys(obj).forEach(function (key) {
          if (obj[key].Option) {
            if (obj[key].Option.value === 'true') {
              options[key] = true
            } else if (obj[key].Option.value === 'false') {
              options[key] = false
            } else {
              options[key] = obj[key].Option.value
            }
          } else {
            options[key] = ''
          }
        })
        this.$root.$store.commit('update', { field: 'optionValues', value: options })
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    },
    loadPreviousCRMReserve () {
      let url = this.$root.baseURL + 'getMembership/crm.json'
      let fields = ['members']
      let _self = this
      let data = {
        // crm_id: this.$root.$store.state.crm_id
        crm_id: this.$root.$store.state.crm_id,
        date: this.$root.$store.state.rentalDate,
        term: this.$root.$store.state.reserve_term,
        introduce: this.$root.$route.query.int
      }
      _self.auth_errors = []
      axios.post(url, JSON.stringify(data), {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        if (response.data.result.auth === true) {
          let p = response.data.result.params
          _self.memberData = p
          if (p.members) {
            _self.$_.each(p.members, function (member, mi) {
              let items = {}
              _self.$_.each(member.rentalItems, function (item) {
                items[item.item] = item
              })
              // p.members[mi].rentalItems = items
              // p.members[mi].item = member.item
              p.members[mi] = member
            })
          }
          _self.$_.each(fields, function (field) {
            _self.$root.$store.commit('update', { field: field, value: p[field] })
          })
          _self.$root.$store.commit('update', { field: 'email_retype', value: p.email })
          _self.$root.$store.commit('update', { field: 'loadedMembership', value: true })
          _self.$root.$store.commit('update', { field: 'members', value: p.members })
          _self.loadCompleted = true
        } else {
          if (response.data.result.errors) {
            _self.auth_errors = response.data.result.errors
          }
        }
        // this.$root.$store.commit('update', { field: 'optionValues', value: options })
        console.log(response)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
        // this.membership_password = ''
      })
    },
    loadMembership () {
      var url = this.$root.baseURL + 'getMembership.json'
      var data = {
        email: this.membership_email,
        password: this.membership_password,
        date: this.$root.$store.state.rentalDate,
        term: this.$root.$store.state.reserve_term,
        int: this.$root.$route.query.int
      }
      var _self = this
      _self.auth_errors = []
      axios.post(url, JSON.stringify(data), {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        if (response.data.result.auth === true) {
          var p = response.data.result.params
          _self.memberData = p
          let fields = ['tel', 'email', 'country', 'idcard', 'privacy', 'zip', 'address', 'address1', 'address2', 'members']
          if (p.members) {
            _self.$_.each(p.members, function (member, mi) {
              var items = {}
              _self.$_.each(member.rentalItems, function (item) {
                items[item.item] = item
              })
              p.members[mi].rentalItems = items
            })
          }
          _self.$_.each(fields, function (field) {
            _self.$root.$store.commit('update', { field: field, value: p[field] })
          })
          _self.$root.$store.commit('update', { field: 'email_retype', value: p.email })
          _self.$root.$store.commit('update', { field: 'loadedMembership', value: true })
          _self.loadCompleted = true
        } else {
          if (response.data.result.errors) {
            _self.auth_errors = response.data.result.errors
          }
        }
        // this.$root.$store.commit('update', { field: 'optionValues', value: options })
        console.log(response)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
        // this.membership_password = ''
      })
    }
  }
}
window.jQuery(function () {
  window.address1Control()
})
window.address1Control = function () {
  let el = window.jQuery('#country-value')
  // 居住国の入力が無い施設(enable_country が false)では #country-value が描画されない。
  // val() が undefined になって居住エリアを消してしまうため、その場合は何もしない #190
  if (!el.length) {
    return
  }
  let crt = el.val()
  if (crt === 'JP') {
    window.jQuery('#address1').show()
  } else {
    window.jQuery('#address1').hide()
  }
}
</script>
<style>
    #keyboard {
        margin-bottom: 1rem;
    }
</style>
